import { useContext } from 'react';
import { UserContext } from '../context';

export function useFirebaseUser() {
  const { firebaseUser, setFirebaseUser } = useContext(UserContext);
  return [firebaseUser, setFirebaseUser] as const;
}
